<convfact-conceptcontact-form [errors]="errors" [contacts]="contacts" 
[conceptContact]="conceptContact" [concepts]="concepts"  *ngIf="conceptContact" 
(onSave)="saveData($event)"></convfact-conceptcontact-form> 